<template>
  <div>
    <slot />
    <portal v-if="active" to="admin-panel-footer">
      <app-button :loading="saving" :label="$t('_RSFAP_SHARED_SAVE')" @click="$emit('save')" />
    </portal>
  </div>
</template>

<script setup>
defineProps({
  active: Boolean,
  saving: Boolean
})
</script>
